import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/auth";

export type loginType = {
  email: string; password: string
}
export type registerType = {
  member_name: string;
  member_last_name: string;
  email: string;
  member_mobile: string;
  password: string;
}
export type validateOtpType = {
  email: string;
  otp: string;
  ref: string;
}
export class AuthApi extends BaseAPI {
  static login(form: loginType): Promise<AxiosResponse> {
    return this.api.post(`${path}/login`, form);
  }
  static register(body: registerType): Promise<AxiosResponse> {
    return this.api.post(`${path}/register`, body)
  }
  static validateOtp(body: validateOtpType): Promise<AxiosResponse> {
    return this.api.post(`${path}/validate-otp`, body)
  }
  static logout(): Promise<AxiosResponse> {
    return this.api.get(`${path}/logout`)
  }
  static password(body: { password: string }, access_token: string): Promise<AxiosResponse> {
    return this.api.patch(`${path}/password`, body, {
      headers: {
        'Authorization': `Bearer ${access_token}`
      }
    })
  }
  static forgot_password(body: { email: string }): Promise<AxiosResponse> {
    return this.api.post(`${path}/forgotpassword`, body)
  }
  static resetPassword(password: string, accessToken: string): Promise<any> {
    return this.api
      .patch(
        `${path}/password`,
        { password },
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      )
      .then((res) => res);
  }
  static forgotPassword(email: string): Promise<any> {
    return this.api
      .post(`${path}/forgotpassword`, { email }, {})
      .then((res) => res);
  }
  static getUser(accessToken?: string): Promise<any> {
    return this.api
      .get(`${path}/profile`, {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((res) => res);
  }
  static getValidateOTP(props: any): Promise<any> {
    return this.api
      .post(`${path}/validate-otp`, { ...props })
      .then((res) => res);
  }
}
